var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.313,
    height: 22.5,
    viewBox: "0 0 25.313 22.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-exclamation-triangle",
    "data-name": "Icon awesome-exclamation-triangle",
    d: "M25.028,19.337A2.111,2.111,0,0,1,23.2,22.5H2.112A2.111,2.111,0,0,1,.285,19.337L10.829,1.054a2.111,2.111,0,0,1,3.654,0Zm-12.371-3.78a2.021,2.021,0,1,0,2.021,2.021A2.021,2.021,0,0,0,12.656,15.557ZM10.737,8.29l.326,5.977a.527.527,0,0,0,.527.5h2.133a.527.527,0,0,0,.527-.5l.326-5.977a.527.527,0,0,0-.527-.556H11.264a.527.527,0,0,0-.527.556Z",
    fill: "#f93d5c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/ErrorIcon.e56dec9dd324ac6733668c2500d8e7ed.svg";
export { ForwardRef as ReactComponent };